export interface AnnualBasis {
  ID: number | string,
  Title: string,
  Amount: number,
  Title_ALT: string
}

export interface ApplicationAddListMainType {
  ID: number | string,
  Title: string,
  Title_ALT?: string | null
}

export interface ApplicationAddListExtended extends ApplicationAddListMainType {
  Active: number
}
export interface ApplicationAddListReduced extends Omit<ApplicationAddListMainType, "Title_ALT"> {
  Active: number
}

export interface ApplicationAddNodes {
  ID: number,
  Title: string,
  DisplayTitle: string,
  Alias: string,
  TaxID: number,
  RegID: number,
  Address: string,
  Phone: string,
  BankAcc: string,
  BankID: number,
  BankTitle: string,
  ManagerStatus: string,
  ManagerName: string,
  CField1: string,
  CField2: string,
  CField3: string,
  CField4: string,
  Email: string,
  CCYRateNotify: string,
  Delegate1: string,
  Delegate1Status: string,
  Delegate1POA: string,
  Delegate2: string,
  Delegate2Status: string,
  Delegate2POA: string,
  Delegate3: string,
  Delegate3Status: string,
  Delegate3POA: string,
  TypeID: number,
  Latitude: string,
  Longitude: string
}

export interface Currency {
  CCY: string,
  AmountMin: number,
  AmountMax: number,
  ISO?: any
}

export interface ProductDetailsServerData {
  ID: number | string,
  Alias: string,
  ProductType: number,
  Title: string,
  ProductGroupID: number,
  Active: number,
  ValidityCheck: number,
  ValidityStartDate: string,
  ValidityEndDate: string,
  CCYCheck: number,
  ScheduleTypeCheck: number,
  InterestCheck: number,
  InterestMin: number,
  InterestMax: number,
  AnnualBasisCheck: number,
  AnnualBasis: number,
  AnnualBasis_LKP: AnnualBasis[],
  PenInterestCheck: number,
  PenInterestMin: number,
  PenInterestMax: number,
  PenPrincipalCheck: number,
  PenPrincipalMin: number,
  PenPrincipalMax: number,
  PenPrepayCheck: number,
  PenPrepayTypeCheck: number,
  PenPrepayType: number,
  PenPrepayType_LKP: ApplicationAddListMainType[],
  PenPrepayMin: number,
  PenPrepayMax: number,
  PenaltyTypeCheck: number,
  PenaltyType: number,
  PenaltyType_LKP: ApplicationAddListMainType[],
  TermDaysCheck: number,
  TermDaysMin: number,
  TermDaysMax: number,
  PurposeCheck: number,
  ProcedureFeeTypeCheck: number,
  ProcedureFeeType: number,
  ProcedureFeeType_LKP: ApplicationAddListMainType[],
  ProcedureFeeAmountCheck: number,
  ProcedureFeeAmountMin: number,
  ProcedureFeeAmountMax: number,
  MinProcedureFeeCheck: number,
  MinProcedureFeeAmount: number,
  ResourceCheck: number,
  LoanTypeCheck: number,
  GracePeriodCheck: number,
  GracePeriodMin: number,
  GracePeriodMax: number,
  RoundCheck: number,
  RoundMin: number,
  RoundMax: number,
  PayFreqCheck: number,
  PayFreqValue: number,
  PayFreqPeriodID: number,
  PayFreqPeriodID_LKP: any[],
  ClientTypeCheck: number,
  FlatCheck: number,
  Flat: number,
  Flat_LKP: ApplicationAddListMainType[],
  AccrualMethodCheck: number,
  AccrualMethod: number,
  AccrualMethod_LKP: ApplicationAddListMainType[],
  GracePeriodIntCheck: number,
  GracePeriodIntMin: number,
  GracePeriodIntMax: number,
  UpfrontInterestCheck: number,
  UpfrontInterest: number,
  UpfrontInterest_LKP: ApplicationAddListMainType[],
  ManualScheduleAllowed: number,
  WeekDaysCheck: number,
  WeekDays: string,
  MonthDaysCheck: number,
  MonthDays: string,
  SkipDirectionCheck: number,
  SkipDirection: number,
  CollateralCheck: number,
  CollateralMin: number,
  CollateralMax: number,
  UCLCCheck: number,
  UCLCMin: number,
  UCLCMax: number,
  ReserveMatrix: number,
  DecisionMatrix: number,
  Comment: string,
  NodeID: number,
  Node_LKP: ApplicationAddNodes[],
  CFG_PenatyGrace: number,
  CFG_AccrueInterestExpire: number,
  CFG_AccruePenaltyExpire: number,
  RevolvingCheck: number,
  Revolving: number,
  Revolving_LKP: ApplicationAddListMainType[],
  AllowParallelLoans: number,
  CFG_TolerableOVD: number,
  CFG_TolerableOVD_Penalty: number,
  CFG_UseInterestOVD: number,
  CFG_IntOVDGrace: number,
  CFG_LimitPenalties: 1000,
  CFG_AllowSchedLessApproved: number,
  ProcedureFeePaymentTypeCheck: number,
  ProcedureFeePaymentTypeID: number,
  ProcedureFeePaymentType_LKP: ApplicationAddListMainType[],
  Collateral121: number,
  MinInterestAccrue: number,
  MinPenPriAccrue: number,
  MinPenIntAccrue: number,
  ProcedureFeeOnRestruct: number,
  DisburseOnlyApprovedCCY: number,
  DefaultIndustryCheck: number,
  DefaultIndustryID: number,
  DefaultIndustry_LKP: ApplicationAddListExtended[],
  CFG_ActLoanColEdit: number,
  CFG_ActLoanColDetach: number,
  CFG_ClosedLoanColDetach: number,
  CFG_ReschOSBalance: number,
  GOLEstimationCatCheck: number,
  GOLEstimationCatID: number,
  GOLEstimationCat_LKP: ApplicationAddListExtended[],
  ConsiderHolidaysCheck: number,
  ConsiderHolidays: number,
  CField1: string,
  CField2: string,
  CField3: string,
  CField4: string,
  GracePeriod_InterestAccrual: number,
  OnEventMSGCheck: number,
  OnEventMSGComment: string,
  CFG_LimitPenalties_Base: number,
  CFG_PenaltyDayOne_Amount: number,
  CFG_PenaltyDayOne_Type: number,
  CFG_PenaltyDayOne_Type_LKP: ApplicationAddListMainType[],
  Client_ReqField_GroupID: number,
  Client_ReqField_Group_LKP: ApplicationAddListMainType[],
  IndustryCheck: number,
  CFG_PenaltyPriority: number,
  ProcedureFeeInstTypeCheck: number,
  ProcedureFeeInstTypeID: number,
  ProcedureFeeInstType_LKP: ApplicationAddListMainType[],
  ProcedureFeeInstPeriodsMin: number,
  ProcedureFeeInstPeriodsMax: number,
  CFG_PenaltyDayOne_MinAmount: number,
  GracePeriod_InterestAccrual_Max: number,
  GracePeriod_InterestAccrual_Check: number,
  UCLCTypeCheck: number,
  UCLCTypeID: number,
  UCLCType_LKP: ApplicationAddListMainType[],
  PRD_Classifier1: number,
  InsProductCheck: number,
  InsProductID: number,
  InsProduct_LKP: ApplicationAddListReduced[],
  InsProductRateMin: number,
  InsProductRateMax: number,
  InsProductRateTypeID: number,
  InsProductRateType_LKP: ApplicationAddListReduced[],
  CCY: Currency[],
  Classifier1: any[],
  ClientType: ApplicationAddListMainType[],
  Industry: ApplicationAddListMainType[],
  INS_Product: any[],
  LoanType: ApplicationAddListMainType[],
  Purpose: ApplicationAddListMainType[],
  Resource: ApplicationAddListMainType[],
  ScheduleType: ApplicationAddListMainType[],
  WorkSchedule: any[],
  AppExpireCheck: number,
  AppExpireDays: number,
  CICheck: number,
  CIMinScore: number,
  CIExpireDays: number,
  CIAutoRejectScore: number,
  CIAutoDecideScore: number,
  RTCheck: number,
  RTMinScore: number,
  RTAutoRejectScore: number,
  RTAutoDecideScore: number,
  AppValidatorsCheck: number,
  AppValidatorsMask: string,
  LBConv: number,
  LBTaxRate: number,
  AppOfferCheck: number,
  Purpose2Check: number,
  CFG_LimitPenalties_AbsAmount: number,
  PRD_Classifier2: number,
  DefaultIndustrySubCheck: number,
  DefaultIndustrySubID: number,
  DefaultIndustrySubDetailCheck: number,
  DefaultIndustrySubDetailID: number,
  AppReqFields: number,
  ReqIndustryCheck: number,
  ReqIndustrySubCheck: number,
  ReqIndustrySubDetailCheck: number,
  AdvRebuildAllowTypeID: number,
  AdvRebuildAllowAmount: number,
  MaxFirstInstDays: number,
  ProductGroupTitle: string,
  ProductGroupParallelLoans: number,
  ProdType_IntBIC: number,
  ReqSpotPMT: number,
  PayFreqPeriod_LKP: ApplicationAddListMainType[],
  RejectReason_LKP: ApplicationAddListExtended[],
  HashSum_ProductID_?: string
}

export interface Product {
  ID: number
  Title: string
  HashSum_ProductID_: string
}

export type ProductList = Product[]

export enum ProductPage {
  Details = 'detail',
  List = 'list',
  BIC = 'bic',
  Pawnshop = 'pawnshop',
}

export enum ProductServiceErrorCode {
  GENERAL,
}

export interface ProductFailure {
  message: string
}
